import { Link, useStaticQuery, StaticQuery, graphql } from "gatsby";
import React from "react";
import logoGreen from "../../static/images/evitat-logo-green.png"
import logoWhite from "../../static/images/evitat-logo-white.png"

export class Header extends React.Component {
    
    state = {toggle: false};
    toggleClass = () => {
        // e.preventDefault();
        this.setState(state => ({
            toggle: !state.toggle
        }), () => {
            if (typeof document !== `undefined`) {
                this.state.toggle ? document.body.classList.add('nav-open') : document.body.classList.remove('nav-open');
            }
        });
    }
    componentWillMount() {
        if (typeof document !== `undefined`) {
            document.body.classList.remove('nav-open');
        }
    }
    componentDidMount() {
       
    }
    render () {
        
        return <header className={"header " + (this.props.type === 'blog' ? 'blog' : 'home') + (this.state.toggle ? ' open' : '') }>
            <div className="header__logo--box">
                { this.props.type === 'blog' ?
                    <Link to="/"><img src={logoWhite} alt="Logo" className="header__logo" /></Link>
                    : <Link to="/"><img src={logoGreen} alt="Logo" className="header__logo" /></Link>
                }
            </div>
            <div onClick={() => this.toggleClass()} id="mySidenav" className="sidenav">
                <ul>
                    <li><Link to="/">Home</Link></li>
                    <StaticQuery
                        query={
                            graphql`
                                query {
                                    allContentfulBlogPost (
                                        sort: {
                                        fields:publishedDate,
                                        order: DESC
                                        }
                                    ){
                                        edges {
                                        node {
                                            categories {
                                                categoryName
                                                categorySlug
                                            }
                                            publishedDate
                                        }
                                        }
                                    }
                                }
                            `
                        }
                        render={data => {
                            const blogPostsData = data.allContentfulBlogPost?.edges;
                            let categories = blogPostsData.map(edge => edge.node.categories);
                            categories = categories.flat(1).reduce((arr, i) => {
                                if (!arr.find(category => category?.categoryName === i?.categoryName)) {
                                    arr.push(i);
                                }
                                return arr;
                            }, []);
                            return categories?.map((x, i) => {
                                return <li key={i}><Link to={`/category/${x?.categorySlug}`}>{ x?.categoryName }</Link></li>
                            })
                    
                        }}
                    />
                    <li><a href="https://www.evitat.com.au/privacy">Privacy</a></li>
                    {/* <li><a href="#">Contact</a></li>  */}
                </ul>
            </div>

            <div className="header__nav">
                <span onClick={() => this.toggleClass()}>&#9776;</span>
            </div>
        </header>;
    }
}
